import { render, staticRenderFns } from "./closeTicketPopup.vue?vue&type=template&id=070ee6af&scoped=true"
import script from "./closeTicketPopup.vue?vue&type=script&lang=js"
export * from "./closeTicketPopup.vue?vue&type=script&lang=js"
import style0 from "./closeTicketPopup.vue?vue&type=style&index=0&id=070ee6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ee6af",
  null
  
)

export default component.exports